export function phoneRecoveryLabel(task) {
  const stage = task?.generation_progress?.stage
  const issue = task?.issue || {}
  if (!['failed', 'waiting_retry'].includes(stage) || issue.retryable !== true ||
      issue.error_code === 'GENERATED_ASSET_PROOF_INCOMPLETE') return ''
  return issue.stage === 'material_download' ? '素材下载中断，等待手机自动重试' : '已保留进度，等待手机自动恢复'
}

export function phoneIssueTitle(task) {
  if (task?.status_dimensions?.generation_state === 'generated' || task?.generation_progress?.stage === 'completed') return '历史恢复记录'
  return phoneRecoveryLabel(task) || task?.issue?.title || '手机任务需要处理'
}
